<template>
<v-card class="client organization locations component my-3">
  <v-card-title class="title">Locations
    <v-spacer />
    <v-dialog v-model="editing" max-width="600px" v-if="edit">
      <v-btn color="secondary darken-2" slot="activator">
        <v-icon left>mdi-pencil</v-icon> Edit
      </v-btn>
      <v-card>
        <v-card-title class="headline">
          Edit Locations
          <v-spacer />
          <v-btn @click="done" flat>Done</v-btn>
          <v-btn color="secondary darken-2" @click="adding = true" v-if="editing && !adding || organization.locations && !organization.locations[0]">
            <v-icon>mdi-plus</v-icon> Add Location
          </v-btn>
        </v-card-title>
        <v-card-text>
          <table class="v-table" v-if="organization.locations && organization.locations[0]">
            <tbody>
              <tr v-for="location in organization.locations" :key="location.id">
                <td class="">
                  <span v-if="location.countryCode" :class="`flag-icon flag-icon-${location.countryCode.toLowerCase()}`"></span>
                  <v-icon v-else>mdi-earth</v-icon>
                  <span>{{ location.address }}</span>
                </td>
                <td class="text-xs-right">
                  <v-tooltip left>
                    <v-btn icon @click="refresh" v-if="!location.countryCode" slot="activator">
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <span>Refresh</span>
                  </v-tooltip>

                  <v-tooltip left>
                    <v-btn icon slot="activator" @click="confirmRemoval(location)">
                      <v-icon color="red darken-4">mdi-delete</v-icon>
                    </v-btn>
                    <span>Remove</span>
                  </v-tooltip>
                </td>
              </tr>
              <v-dialog v-model="removing" max-width="500px">
                <v-card>
                  <v-card-title>
                    <div class="headline">Remove Location</div>
                  </v-card-title>
                  <v-card-text v-if="address">
                    Are you sure you want to remove {{ address.address }}?
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn flat @click="removing = null">Cancel</v-btn>
                    <v-btn color="error" @click="remove">Remove</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </tbody>
          </table>

          <v-card-text v-if="adding">
            <v-form v-model="valid" @submit.prevent="submit">
              <v-text-field v-model="address" label="New Address" :rules="rules.address" :error-messages="errors.address || []" required />
            </v-form>
            <v-card-actions>
              <v-spacer />
              <v-btn flat @click="adding = false">
                Cancel
              </v-btn>
              <v-btn :color="valid ? 'success' : 'error'" :disabled="!valid" @click="submit">
                Add
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card-title>

  <v-img height="400px" v-if="organization.locations && organization.locations[0]">
    <leaply-map :markers="organization.locations" width="100%" height="400px"/>
  </v-img>
  <v-card-text v-else>
    <v-chip color="secondary darken-2 white--text">
      <v-icon left>mdi-info</v-icon>
      There aren't any locations to display. Please add locations.
    </v-chip>
  </v-card-text>
</v-card>
</template>

<script>
export default {
  props: { organization: Object, edit: Boolean },
  data() {
    return {
      editing: false,
      adding: false,
      removing: false,
      valid: false,
      rules: {
        address: [v => !!v || 'must be specified']
      },
      errors: {},
      address: null
    }
  },
  methods: {
    done() {
      this.editing = false
      this.adding = false
      this.removing = false
      this.errors = {}
      this.address = null
    },
    submit() {
      if (this.valid) this.create()
    },
    create() {
      this.$store
        .dispatch('client/organization/createLocation', {
          address: this.address,
          organization: {
            id: this.organization.id
          }
        })
        .then(errors => {
          if (errors) {
            this.errors = errors
            this.$store.commit('snackbar', {
              text: 'There was a problem adding the new address',
              type: 'error'
            })
          } else {
            this.$store.commit('snackbar', {
              text: 'The address was added successfully',
              type: 'success'
            })
            this.address = null
            this.adding = false
          }
        })
    },
    confirmRemoval(location) {
      this.removing = true
      this.address = location
    },
    remove() {
      this.$store
        .dispatch('client/organization/removeLocation', {
          ...this.address,
          organization: {
            id: this.organization.id
          }
        })
        .then(errors => {
          if (errors) {
            this.$store.commit('snackbar', {
              text: 'There was a problem removing the address',
              type: 'error'
            })
          } else {
            this.$store.commit('snackbar', {
              text: 'The address was removed successfully',
              type: 'success'
            })
            this.done()
          }
        })
    },
    refresh() {
      this.$store.dispatch('client/organization/fetch', this.$route.params.id)
    }
  }
}
</script>
